import {useContext, useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core";
import {uid} from "react-uid";
import {del, insert, set} from 'object-path-immutable'
import GroupContainer from "./GroupContainer";
import FilterItem from "./FilterItem";
import {SelectionCriteriaContext} from "./SelectionCriteriaContext";
import {SelectionCriteriaContext as SelectionCriteriaContextOld} from '../SelectionCriteria/SelectionCriteriaContext'
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {ACTIONS} from "../SelectionCriteria/SelectionCriteria";
import PropTypes from "prop-types";

const value = {
    front: {field: {label: "", value: ""}, operand: {label: "", value: ""}, value: ''},
    default: {field: "", operand: "", value: ""}
};
const group = {
    front: {"or": [value.front]},
    default: {"or": [value.default]},
}
const data = [
    value,
    // {
    //     "or": [
    //         value,
    //         value,
    //     ]
    // },
    // value,
    // {"and": [value, value, {"or": [value, value]}, value]},

]

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 0'
    },
    filterContainer: {
        // minHeight: 200,
        // minWidth: 500,
        background: '#fff',
        padding: '5px 30px 5px 0',
    }
}))

const SelectionCriteriaDev = (props) => {
    const {componentPath, setValue, withoutGroups} = props;
    const {
        currentFilterFront,
        dispatch,
        currentFilter
    } = useContext(SelectionCriteriaContextOld)
    const [filter, setFilter] = useState(data);
    const classes = useStyles();

    useEffect(() => {

    }, [])

    function addItem(path, index, direction) {
        try {
            const newValues = insert(filter, path, value, index + direction)

            const newCurrentFilter = insert(currentFilter, path, value.default, index + direction);
            const newCurrentFilterFront = insert(currentFilterFront, path, value.front, index + direction);
            dispatch({
                type: ACTIONS.UPDATE_CURRENT_FILTER,
                payload: {
                    currentFilterFront: newCurrentFilterFront,
                    currentFilter: newCurrentFilter
                }
            });
            setFilter(newValues)
            setValue && setValue(newCurrentFilter, componentPath)
        } catch (e) {
            console.log('add item error', e);
        }
    }

    function addGroup(path, index, direction) {
        try {
            const newValues = insert(filter, path, group, index + direction)
            const newCurrentFilter = insert(currentFilter, path, group.default, index + direction)
            const newCurrentFilterFront = insert(currentFilterFront, path, group.front, index + direction)
            dispatch({
                type: ACTIONS.UPDATE_CURRENT_FILTER,
                payload: {
                    currentFilterFront: newCurrentFilterFront,
                    currentFilter: newCurrentFilter
                }
            });
            setFilter(newValues)
            setValue && setValue(newCurrentFilter, componentPath)
        } catch (e) {
            console.log('add group error', e);
        }
    }

    function changeOperator(path, index, {current, updated}) {
        const currentGroup = findByString(currentFilter, path ? `${path}.${index}.${current}` : `${index}.${current}`);
        const newValues = set(currentFilter, path ? `${path}.${index}` : `${index}`, {[updated]: currentGroup})

        const currentGroupFront = findByString(currentFilterFront, path ? `${path}.${index}.${current}` : `${index}.${current}`);
        const newValuesFront = set(currentFilterFront, path ? `${path}.${index}` : `${index}`, {[updated]: currentGroupFront})
        setValue && setValue(newValues, componentPath)
        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {
                currentFilterFront: newValuesFront,
                currentFilter: newValues
            }
        });
        // const currentGroup = findByString(filter, path ? `${path}.${index}.${current}` : `${index}.${current}`);
        // const newValues = set(filter, path ? `${path}.${index}` : `${index}`, {[updated]: currentGroup})
        // setFilter(newValues)
    }

    function remove(path, index) {
        const containerPath = path ? path.split('.').slice(0, path.split('.').length - 1).join('.') : `${index}`;
        let containerLength = findByString(currentFilterFront, path ? path : '').length;

        //if deleting last item, replace with empty object
        if (containerLength === 1 && !path) {
            dispatch({
                type: ACTIONS.UPDATE_CURRENT_FILTER,
                payload: {
                    currentFilterFront: [value.front],
                    currentFilter: [value.default]
                }
            });
            setValue && setValue([value.default], componentPath)
            return
        }


        if (containerLength === 1) {
            const newValues = del(currentFilter, containerPath)
            const newValuesFront = del(currentFilterFront, containerPath)
            dispatch({
                type: ACTIONS.UPDATE_CURRENT_FILTER,
                payload: {
                    currentFilterFront: newValuesFront,
                    currentFilter: newValues
                }
            });
            setValue && setValue(newValues, componentPath)
            return
        }
        const newValues = del(currentFilter, path ? path + '.' + index : `${index}`)
        const newValuesFront = del(currentFilterFront, path ? path + '.' + index : `${index}`)
        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {
                currentFilterFront: newValuesFront,
                currentFilter: newValues
            }
        });
        setValue && setValue(newValues, componentPath)
    }

    return (
        <div className={classes.container}>
            <div className={classes.filterContainer}>
                <SelectionCriteriaContext.Provider value={{
                    addItem,
                    addGroup,
                    remove,
                    changeOperator,
                    withoutGroups
                }}>
                    <TreeRender tree={currentFilterFront} level={0}/>
                </SelectionCriteriaContext.Provider>
            </div>
        </div>
    )
}
export default SelectionCriteriaDev

SelectionCriteriaDev.propTypes = {
    withoutGroups: PropTypes.bool,
    setValue: PropTypes.func,
    componentPath: PropTypes.string
}

const TreeRender = ({tree, level = 0, path}) => {
    const firstDisabledValue = Math.min(
        ...tree.map((v, i) => ({...v, i}))
            .filter(f => !f.value)
            .map(v => v.i));

    return tree.map((item, index) => {
        if (item['or']) {
            return <GroupContainer type={"or"} key={uid(item)} level={level}
                                   path={path ? path : ``}
                                   index={index}
            >
                <TreeRender tree={item['or']} level={level + 1}
                            path={path ? path + '.' + index + `.or` : index + `.or`}/>
            </GroupContainer>
        }
        if (item['and']) {
            return <GroupContainer
                type={'and'} key={uid(item)} level={level}
                path={path ? path : ``}
                index={index}
            >
                <TreeRender tree={item['and']} level={level + 1}
                            path={path ? path + '.' + index + `.and` : index + `.and`}/>
            </GroupContainer>
        }

        return <FilterItem key={uid(index)}
                           path={path}
                           index={index}
                           item={item}
                           firstDisabledValue={firstDisabledValue}
        />
    })
}